module.exports = __webpack_public_path__ + "img/24.1fb65eb4.png";